"use strict";
import { createAction } from "@reduxjs/toolkit";
export const updateVersion = createAction("global/updateVersion");
